interface StreakDisplayProps {
  currentStreak: number;
  longestStreak: number;
}

export function StreakDisplay({ currentStreak, longestStreak }: StreakDisplayProps) {
  const lit = currentStreak > 0;
  return (
    <div className="streak-row">
      <div className="streak-stat">
        <div className="value">
          <span className={`streak-flame${lit ? ' lit' : ''}`} aria-hidden="true">🔥</span> {currentStreak}
        </div>
        <div className="label">Current streak</div>
      </div>
      <div className="streak-stat">
        <div className="value">{longestStreak}</div>
        <div className="label">Longest streak</div>
      </div>
    </div>
  );
}
